module.exports = __webpack_public_path__ + "static/hand_app-25bf03e3566319b8f9bd609fa0d16610.png";